import { AccountPosition } from '../../type';

export const computeExRatePerformance = (line: AccountPosition | null | undefined) => {
  if (line) {
    const performance = ((line['GES_ESTIM_D.EXRATE_BUY'] ?? 1) / (line['GES_ESTIM_D.EXRATE'] ?? 1)) - 1;
    return performance;
  }
  return 0;
};
